const json = {
    GE: {
        'Wine Almighty': 'პირველი ღვინო',
        'Tipsy Adventure': 'ღვინო ყველგან',
        'Tradition of Supra': 'ქართული სუფრა',
        'Colorful Cuisine': 'ფერადი სამზარეულო',
        History: 'ისტორია',
        Culture: 'კულტურა',
        Architecture: 'არქიტექტურა',
        Tbilisi: 'თბილისი',
        Highlands: 'მთები',
        'Ski Resorts': 'ზამთრის კურორტები',
        'Black Sea': 'შავი ზღვა',
        Nature: 'ბუნება',
        Adventure: 'თავგადასავლები',
        ყველა: 'All',
        'პირველი ღვინო': 'Wine Almighty',
        'ღვინო ყველგან': 'Tipsy Adventure',
        'ქართული სუფრა': 'Tradition of Supra',
        'ფერადი სამზარეულო': 'Colorful Cuisine',
        ისტორია: 'History',
        კულტურა: 'Culture',
        არქიტექტურა: 'Architecture',
        თბილისი: 'Tbilisi',
        მთები: 'Highlands',
        'ზამთრის კურორტები': 'Ski Resorts',
        'შავი ზღვა': 'Black Sea',
        ბუნება: 'Nature',
        თავგადასავლები: 'Adventure',
        TITLE: 'დააგენერირე პერსონალიზებული გზამკვლევი, შენი ინტერესებით',
        SUB_TITLE: 'ან გვიპასუხეთ რამდენიმე კითხვაზე',
        FB_ACCESS: 'facebook-ით დაკავშირება',
        QUESTION: 'რას ანიჭებთ უპირატესობას?',
        CLOSE: 'დახურვა',
        BEEN_IN_GEORGIA_ONE: 'ყოფილხარ საქართველოში? გაიგე, ხარ თუ არა',
        BEEN_IN_GEORGIA_TWO: 'ავტორი',
        BY_TOURISTS: '7.000.000 ტურისტი',
        SHARE: 'გაზიარება',
        OWNER_TEXT: '-ს გზამკვლევი',
        SWIPE: 'გადაფურცლე',
        CURRENT_PAGE_TEXT: 'გვერდი',
        TOTAL_PAGE_TEXT: 'ჯამში'
    },
    EN: {
        'Wine Almighty': 'Wine Almighty',
        'Tipsy Adventure': 'Tipsy Adventure',
        'Tradition of Supra': 'Tradition of Supra',
        'Colorful Cuisine': 'Colorful Cuisine',
        History: 'History',
        Culture: 'Culture',
        Architecture: 'Architecture',
        Tbilisi: 'Tbilisi',
        Highlands: 'Highlands',
        'Ski Resorts': 'Ski Resorts',
        'Black Sea': 'Black Sea',
        Nature: 'Nature',
        Adventure: 'Adventure',
        ყველა: 'All',
        'პირველი ღვინო': 'Wine Almighty',
        'ღვინო ყველგან': 'Tipsy Adventure',
        'ქართული სუფრა': 'Tradition of Supra',
        'ფერადი სამზარეულო': 'Colorful Cuisine',
        ისტორია: 'History',
        კულტურა: 'Culture',
        არქიტექტურა: 'Architecture',
        თბილისი: 'Tbilisi',
        მთები: 'Highlands',
        'ზამთრის კურორტები': 'Ski Resorts',
        'შავი ზღვა': 'Black Sea',
        ბუნება: 'Nature',
        თავგადასავლები: 'Adventure',
        TITLE: 'Generate a personal guidebook based on your interests',
        SUB_TITLE: 'or tell us a bit about yourself',
        FB_ACCESS: 'Access with facebook',
        QUESTION: 'What do you prefer?',
        CLOSE: 'Close',
        BEEN_IN_GEORGIA_ONE: 'Have you ever been in Georgia? Find out if you are',
        BEEN_IN_GEORGIA_TWO: 'a contributor',
        BY_TOURISTS: 'by 7.000.000 tourists',
        SHARE: 'Share guidebook',
        OWNER_TEXT: '\'s Guidebook',
        SWIPE: 'Swipe',
        CURRENT_PAGE_TEXT: 'Page',
        TOTAL_PAGE_TEXT: 'of'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/home/book/book.texts.js